import clsx from 'clsx'
import IconButton from '@material-ui/core/IconButton'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import { makeStyles } from '@material-ui/core/styles'

type LogoutViewType = {
    onClickLogout: () => void
}
const LogoutView = (props: LogoutViewType) => {
    const { onClickLogout } = props
    const classes = useStyles()
    return (
        <>
            <IconButton
                // color="primary"
                size="small"
                aria-label="open drawer"
                onClick={onClickLogout}
                edge="start"
                className={clsx(classes.menuButton)}
            >
                <ExitToAppIcon color={'action'} style={{ fontSize: '25px' }} />
            </IconButton>
        </>
    )
}

const Logout = () => {
    const handleClickLogout = () => {
        localStorage.clear()
        window.location.replace(process.env.PUBLIC_URL)
    }
    return <LogoutView onClickLogout={handleClickLogout} />
}

export default Logout
const useStyles = makeStyles((theme) => ({
    menuButton: {
        marginRight: theme.spacing(2),
    },
}))
